import { fetcher } from '@commenda/utils';

import { IApiResponse } from './types';

export interface IRestoreFolderParams {
  folderId: string;
}

export async function restoreFolder({
  folderId,
}: IRestoreFolderParams): Promise<IApiResponse<null>> {
  const response = await fetcher('drive-view/folder/restore', {
    method: 'POST',
    body: { folderId },
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    return {
      success: false,
      error: body?.message || 'Failed to restore folder',
      statusCode: response.status,
      data: null,
    };
  }

  return {
    success: true,
    error: null,
    statusCode: response.status,
    data: null,
  };
}
